import { render, staticRenderFns } from "./TimelineItemRecurrence.vue?vue&type=template&id=22c4d37e"
import script from "./TimelineItemRecurrence.vue?vue&type=script&lang=ts"
export * from "./TimelineItemRecurrence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports